import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import api, { formatApiErrorDetail } from "@/lib/api";
import { fmtDateTime, btnBrand } from "@/lib/academyFormat";
import { ACADEMY } from "@/constants/testIds";

// Fix U (2026-10-13): historial de notas de un interesado y nota nueva.
export default function LeadNotesModal({ open, onOpenChange, lead, onSaved }) {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  if (!lead) return null;
  const notes = [...(lead.notes || [])].reverse();

  const add = async () => {
    if (!text.trim()) return;
    setSaving(true);
    setError("");
    try {
      const { data } = await api.post(`/academy/leads/${lead.id}/notes`, { text: text.trim() });
      setText("");
      onSaved(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid={ACADEMY.notesModal}>
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Notas de {lead.name}</DialogTitle>
          <DialogDescription className="sr-only">Historial de contacto</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Qué hablaron, qué quedó pendiente" data-testid={ACADEMY.notesInput} />
          {error && <p className="text-sm text-destructive">{error}</p>}
          <div className="flex justify-end">
            <Button className={btnBrand} onClick={add} disabled={saving || !text.trim()} data-testid={ACADEMY.notesAddButton}>{saving ? "Guardando..." : "Agregar nota"}</Button>
          </div>
          <div className="space-y-2 pt-2">
            {notes.length === 0 ? (
              <p className="text-sm text-muted-foreground">Todavía no hay notas.</p>
            ) : notes.map((n, i) => (
              <div key={i} className="border border-border rounded-lg p-3 bg-[#F8FCFC]">
                <p className="text-sm text-foreground whitespace-pre-wrap">{n.text}</p>
                <p className="text-xs text-muted-foreground mt-1">{n.by_name} · {fmtDateTime(n.at)}</p>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
